export const iconFontAwesomeWeatherWater = (
	<i className="fa-solid fa-water"></i>
);
